import React, { useState } from "react";
import networkErrorIcon from '../assets/img/global/networkErrorIcon.png';
import '../assets/css/error.scss'
// import constants from "../lib/constants/constants";

const NetWorkError = (props) => {
	const [path,] = useState(props.location.state.from)
	// useEffect(()=>{
	// 	setPath(props.location.state.from)
	// }, [])
	return(
		<div id="error" className="page dashboard-error">
			<section className="error-box">
				<p><img src={networkErrorIcon} alt="error"/></p>
				<p>
					<strong>대시보드 정보를 가져오지 못했어요.</strong>
					<span>네트워크 연결 상태를 확인하여 주시거나 제품의 연결 상태를 확인하신 후 다시 시도해주세요.</span>
				</p>
				<button className="btn" onClick={()=> window.location.href=path}>새로고침</button>
			</section>
		</div>
	);
}

export default NetWorkError;



